export default __webpack_public_path__ + "static/media/6.9b6ac2e8.mp3";